import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export default function Reveal({
    children,
    delay = 0,
    y = 28,
    className = "",
    once = true,
    ...rest
}) {
    return (
        <motion.div
            className={className}
            {...rest}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, amount: 0.15 }}
            transition={{ duration: 0.7, delay, ease: EASE }}
        >
            {children}
        </motion.div>
    );
}

export function SectionHeader({ eyebrow, title, align = "start" }) {
    return (
        <div
            className={`flex flex-col gap-4 ${
                align === "center" ? "items-center text-center" : "items-start"
            }`}
        >
            <Reveal>
                <span className="font-mono-x text-[11px] sm:text-xs tracking-[0.35em] text-brass uppercase">
                    {eyebrow}
                </span>
            </Reveal>
            <Reveal delay={0.08}>
                <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold text-txt-1 text-balance leading-snug">
                    {title}
                </h2>
            </Reveal>
            <Reveal delay={0.14}>
                <span className="block h-px w-16 bg-gradient-to-r from-brass to-transparent" />
            </Reveal>
        </div>
    );
}
